import { Injectable } from '@angular/core';

import { retryStrategy } from '@personal-area/global/http/services';
import { AuthService } from '@personal-area/global/authorization/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  map,
  of,
  retryWhen,
  switchMap,
} from 'rxjs';

import { VerificationProfileApiService } from '../../services/verification-profile-api.service';
import * as summaryActions from '../actions/summary';

@Injectable()
export class SummaryVerificationEffects {
  constructor(
    private _actions$: Actions,
    private _summaryVerificationApiService: VerificationProfileApiService,
    private _authService: AuthService,
  ) {}

  public getSummary$ = createEffect(() =>
    this._actions$.pipe(
      ofType(summaryActions.GetSummary),
      switchMap(() =>
        this._summaryVerificationApiService
          .getStatus(this._authService.userId)
          .pipe(
            map(summaryActions.GetSummarySuccess),
            retryWhen(retryStrategy()),
            catchError(() => of(summaryActions.GetSummaryFail())),
          ),
      ),
    ),
  );

}
